module.exports = __webpack_public_path__ + "img/paul6x6_65-2.1317d1d1.jpg";